import React, { useState, useCallback, useRef } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import loadImage from "blueimp-load-image/js";
import uploadIcon from "../../images/upload-icon.png";

export default function UploadArea(props) {
  const [hideUpload, setHideUpload] = useState(false);
  const [upImg, setUpImg] = useState();
  const imgRef = useRef(null);
  const [crop, setCrop] = useState({ unit: "%", width: 95, aspect: 1 });
  const [previewUrl, setPreviewUrl] = useState();
  const fileUploadRef = useRef(null);

  const onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      loadImage(
        e.target.files[0],
        (img) => {
          var base64data = img.toDataURL(`image/jpeg`);
          setUpImg(base64data);
        },
        { orientation: true, canvas: true }
      );
    }
  };

  const onLoad = useCallback((img) => {
    imgRef.current = img;
  }, []);

  const makeClientCrop = async (crop) => {
    if (imgRef.current && crop.width && crop.height) {
      createCropPreview(imgRef.current, crop, "newFile.jpeg");
    }
  };

  const createCropPreview = async (image, crop, fileName) => {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error("Canvas is empty"));
          return;
        }
        blob.name = fileName;
        window.URL.revokeObjectURL(previewUrl);
        setPreviewUrl(window.URL.createObjectURL(blob));
      }, "image/jpeg");
    });
  };

  return (
    <div className="upload-area">
        <button
          className="upload-btn"
          onClick={() => {
            fileUploadRef.current.click();
            setHideUpload(true);
          }}
        >
          UPLOAD <img alt="Upload icon" src={uploadIcon} />
        </button>
      <input
        type="file"
        ref={fileUploadRef}
        style={{ display: "none" }}
        onChange={onSelectFile}
        accept="image/*"
      />
      <ReactCrop
        src={upImg}
        onImageLoaded={onLoad}
        crop={crop}
        onChange={(c) => setCrop(c)}
        onComplete={makeClientCrop}
      />
      {previewUrl && (
        <img
          alt="Crop preview"
          onLoad={() => props.onLoad(previewUrl)}
          src={previewUrl}
          ref={props.imageRef}
          style={{ display: "none" }}
        />
      )}
    </div>
  );
}
